"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
var fromEntries = require('object.fromentries');
function init(form) {
    var card = new ShoppingCard(form);
}
exports.init = init;
var ShoppingCard = /** @class */ (function () {
    function ShoppingCard(form) {
        var _this = this;
        var _a;
        this.form = form;
        this.analytes = new Map();
        this.profiles = new Map();
        this.laboratory_result_id = parseInt((_a = form.getAttribute('data-laboratory-result-id')) !== null && _a !== void 0 ? _a : '0');
        if (this.laboratory_result_id === 0)
            throw new Error('require laboratory-result-id attribute');
        form.addEventListener('change', function (event) {
            if (!(event.target instanceof HTMLInputElement))
                return;
            _this.update_analyte(event.target);
            _this.update_profile(event.target);
        });
        form.addEventListener('submit', function () {
            _this.post_request().then(function (response) {
                var _a;
                (_a = window.popups.get('message-success')) === null || _a === void 0 ? void 0 : _a.open();
            }).catch(function (error) {
                var _a;
                (_a = window.popups.get('message-fail')) === null || _a === void 0 ? void 0 : _a.open();
                return {
                    success: false,
                    response: error,
                };
            });
        });
        document.addEventListener('lgm.finish-load-more', function () {
            _this.load_analyte();
            _this.load_profiles();
        });
    }
    ShoppingCard.prototype.update_analyte = function (item_element) {
        var id = this.get_analyte_id_by_name(item_element.name);
        if (!id)
            return;
        var item = this.analytes.get(id);
        if (!item)
            return console.error('Unknown item change ' + id);
        item.set_selected(item_element.checked);
    };
    ShoppingCard.prototype.update_profile = function (profile_element) {
        var _this = this;
        var profile_id = this.get_analyte_profile_id_by_name(profile_element.name);
        if (!profile_id)
            return;
        var profile = this.profiles.get(profile_id);
        if (!profile)
            return console.error('Unknown profile change ' + profile_id);
        profile.set_selected(profile_element.checked);
        profile.analyte_ids.forEach(function (analyte_id) {
            var _a;
            var analyte = (_a = _this.analytes.get(analyte_id)) !== null && _a !== void 0 ? _a : new Analyte(analyte_id);
            // remove this profile from selected via
            analyte.selected_via_profile = analyte.selected_via_profile
                .filter(function (current_profile_id) { return current_profile_id !== profile_id; });
            if (profile_element.checked) {
                // add this profile to selected via
                analyte.selected_via_profile.push(profile_id);
            }
            _this.update_analyte_element_row_by_analyte_state(analyte);
        });
    };
    ShoppingCard.prototype.update_analyte_element_row_by_analyte_state = function (analyte) {
        var analyte_id = analyte.id;
        // update the element in the form if
        var analyte_element = this.form.querySelector('[name="analyte-' + analyte_id + '"]');
        if (analyte_element instanceof HTMLInputElement) {
            analyte_element.checked = analyte.is_selected();
            analyte_element.disabled = analyte.is_disabled();
            // Set the row color according to its state
            var analyte_row_element = (0, utils_1.get_parent_element_by_class)(analyte_element, 'analyte-index-item');
            if (analyte_row_element) {
                analyte_row_element.classList.remove('bg-white', 'odd:bg-gray-200', 'bg-red-400', 'bg-gray-700');
                if (analyte.is_forbidden()) {
                    analyte_row_element.classList.add('bg-red-400');
                }
                else if (analyte.is_indirectly_selected()) {
                    analyte_row_element.classList.add('bg-gray-700');
                }
                else {
                    analyte_row_element.classList.add('bg-white');
                }
            }
        }
    };
    /**
     *
     */
    ShoppingCard.prototype.get_form_analytes = function () {
        var elements = this.form.querySelectorAll('input');
        var buffer = [];
        for (var i = 0; i < elements.length; ++i) {
            var item = elements.item(i);
            if (!item || item.name.match(/analyte-[0-9]+/) === null)
                continue;
            buffer.push(item);
        }
        return buffer;
    };
    ShoppingCard.prototype.get_form_profiles = function () {
        var elements = this.form.querySelectorAll('input');
        var buffer = [];
        for (var i = 0; i < elements.length; ++i) {
            var profile = elements.item(i);
            if (!profile || profile.name.match(/analyte-profile-[0-9]+/) === null)
                continue;
            buffer.push(profile);
        }
        return buffer;
    };
    ShoppingCard.prototype.load_analyte = function () {
        var _this = this;
        var form_data = this.get_form_analytes();
        form_data.forEach(function (analyte_element) {
            var _a;
            var id = _this.get_analyte_id_by_name(analyte_element.name);
            var analyte = (_a = _this.analytes.get(id)) !== null && _a !== void 0 ? _a : new Analyte(id);
            if (analyte_element.disabled) {
                analyte.selected = false;
                analyte.disabled = true;
            }
            // create the analyte and link it to profiles that have selected it
            _this.profiles.forEach(function (profile) {
                if (profile.selected && profile.analyte_ids.includes(analyte.id)) {
                    analyte.selected_via_profile.push(profile.id);
                }
            });
            _this.analytes.set(id, analyte);
            _this.update_analyte_element_row_by_analyte_state(analyte);
        });
    };
    ShoppingCard.prototype.load_profiles = function () {
        var _this = this;
        var form_data = this.get_form_profiles();
        form_data.forEach(function (profile_element) {
            var _a, _b;
            var id = _this.get_analyte_profile_id_by_name(profile_element.name);
            var item_ids = (_a = profile_element.getAttribute('data-analytes')) === null || _a === void 0 ? void 0 : _a.split(',').map(function (x) { return parseInt(x); });
            var profile = (_b = _this.profiles.get(id)) !== null && _b !== void 0 ? _b : new Profile(id, item_ids !== null && item_ids !== void 0 ? item_ids : []);
            if (profile_element.disabled) {
                profile.selected = false;
                profile.disabled = true;
            }
            profile_element.checked = profile.selected;
            _this.profiles.set(id, profile);
        });
    };
    ShoppingCard.prototype.get_analyte_profile_id_by_name = function (name) {
        return parseInt(name.substr("analyte-profile-".length));
    };
    ShoppingCard.prototype.get_analyte_id_by_name = function (name) {
        return parseInt(name.substr("analyte-".length));
    };
    ShoppingCard.prototype.post_request = function () {
        var _this = this;
        var items = __spreadArray([], __read(this.analytes.entries()), false).filter(function (_a) {
            var _b = __read(_a, 2), id = _b[0], item = _b[1];
            return item.is_selected();
        })
            .map(function (_a) {
            var _b = __read(_a, 2), id = _b[0], item = _b[1];
            return [
                'analyte-' + id.toString(),
                (item.is_selected())
                    ? 'true'
                    : 'false'
            ];
        });
        // add analytes selected via profiles that have not been loaded
        this.profiles.forEach(function (profile) {
            if (profile.selected) {
                profile.analyte_ids.forEach(function (analyte_id) {
                    var analyte_index = 'analyte-' + analyte_id.toString();
                    var search_index = items.findIndex(function (item) { return item[0] === analyte_index; });
                    if (search_index >= 0) {
                        items[search_index][1] = 'true';
                    }
                    else {
                        items.push([
                            analyte_index,
                            'true'
                        ]);
                    }
                });
            }
        });
        var token = new FormData(this.form).get('_token');
        if (typeof token !== "string")
            throw new Error('Token is missing');
        items.push([
            '_token',
            token,
        ]);
        var url_encoded_form_body = new URLSearchParams(items);
        return fetch('/analytes/request-for/' + this.laboratory_result_id.toString(), {
            method: 'post',
            body: url_encoded_form_body,
        })
            .then(utils_1.handle_fetch_json_response)
            .then(function (response) {
            _this.analytes.forEach(function (item) {
                item.selected = false;
                item.selected_via_profile = [];
                _this.update_analyte_element_row_by_analyte_state(item);
            });
            _this.profiles.forEach(function (profile) {
                profile.selected = false;
            });
            _this.get_form_profiles().forEach(function (profile) {
                profile.checked = false;
            });
        });
    };
    return ShoppingCard;
}());
var Analyte = /** @class */ (function () {
    function Analyte(id, selected, disabled, selected_via_profile) {
        if (selected === void 0) { selected = false; }
        if (disabled === void 0) { disabled = false; }
        if (selected_via_profile === void 0) { selected_via_profile = []; }
        this.id = id;
        this.selected = selected;
        this.disabled = disabled;
        this.selected_via_profile = selected_via_profile;
    }
    Analyte.prototype.set_selected = function (value) {
        if (this.disabled)
            return;
        if (this.selected_via_profile.length > 0)
            return;
        this.selected = value;
    };
    Analyte.prototype.is_indirectly_selected = function () {
        return this.selected_via_profile.length > 0;
    };
    Analyte.prototype.is_disabled = function () {
        return this.disabled || this.selected_via_profile.length > 0;
    };
    Analyte.prototype.is_selected = function () {
        return this.selected || this.selected_via_profile.length > 0;
    };
    Analyte.prototype.is_forbidden = function () {
        return this.disabled;
    };
    return Analyte;
}());
var Profile = /** @class */ (function () {
    function Profile(id, analyte_ids, selected, disabled) {
        if (selected === void 0) { selected = false; }
        if (disabled === void 0) { disabled = false; }
        this.id = id;
        this.analyte_ids = analyte_ids;
        this.selected = selected;
        this.disabled = disabled;
    }
    Profile.prototype.set_selected = function (value) {
        if (this.disabled)
            return;
        // if (this.selected_via_profile.length > 0) return;
        this.selected = value;
    };
    return Profile;
}());
